/**
 * Semantic color exports from the app theme.
 * Use these instead of hardcoded hex so layout and components stay in sync with theme.json.
 */
import theme from './theme.json';

const g = theme.ouroraColors.grey as Record<string, string>;
const pink = theme.ouroraColors.pink as Record<string, string>;
const red = theme.ouroraColors.red as Record<string, string>;
const green = theme.ouroraColors.green as Record<string, string>;
const blue = theme.ouroraColors.blue as Record<string, string>;
const basics = theme.ouroraColors.basics as Record<string, string>;
const token = theme.token as unknown as Record<string, string>;

export const colors = {
  // Backgrounds (using existing grey scale only)
  bgBase: token.colorBgBase ?? g.Grey25,
  bgElevated: g.Grey50,
  bgRaised: g.Grey75,

  // Text
  textPrimary: token.colorTextBase ?? g.Grey120,
  textMuted: g.Grey100,
  textInverse: g.Grey25,
  white: basics.Black,
  black: basics.White,

  // Borders
  border: g.Grey50,

  // Brand & semantic
  primary: token.colorPrimary ?? pink.Pink100,
  error: token.colorError ?? red.Red50,
  success: token.colorSuccess ?? green.Green100,
  info: token.colorInfo ?? blue.Blue100,
} as const;

export default colors;
